import { styled } from '@mui/material/styles';
import { Button as BaseButton } from 'components/buttons';
import Link from 'components/Link';

export const Button = styled(BaseButton)(({ align }) => ({
  minWidth: '150px',
  ...(align === 'left' && {
    marginRight: 'auto'
  })
}));

export const CVLink = styled(Link)(({ theme, disabled }) => ({
  fontSize: theme.fontSize.xsmall,
  ...(disabled && {
    '&, & *': {
      color: theme.color.disabled.text,
      pointerEvents: 'none'
    }
  })
}));

export const LinkText = styled('span')(({ theme }) => ({
  color: theme.color.primary.main,
  fontWeight: theme.fontWeight.bold,
  marginLeft: theme.spacing(1),
  textTransform: 'uppercase'
}));

export const Section = styled('div')(({ wrap, justify }) => ({
  alignItems: 'center',
  display: 'flex',
  flexGrow: 1,
  flexWrap: wrap || 'wrap',
  ...(justify && {
    justifyContent: justify
  }),
  '@media (max-width: 400px)': {
    justifyContent: 'center'
  }
}));

export const FooterItem = styled('div')(() => ({
  alignItems: 'center',
  display: 'flex',
  '.MuiFormControlLabel-root': {
    marginLeft: 0,
    marginRight: 0
  }
}));

export const FooterContent = styled('div')(({ theme, wrap }) => ({
  justifyContent: 'center',
  display: 'flex',
  flexDirection: 'column',
  flexWrap: wrap || 'wrap',
  margin: theme.spacing(-1.5),
  width: `calc(100% + ${theme.spacing(3)})`,
  [`& ${FooterItem}`]: {
    margin: theme.spacing(1.5)
  },
  [`& ${Button}`]: {
    '@media (max-width: 400px)': {
      flex: '1 1 100%'
    }
  }
}));

export const ActionsFooter = styled('div')(({ theme }) => ({
  borderTop: `1px solid ${theme.color.grey[500]}`,
  boxSizing: 'border-box',
  margin: `0 ${theme.spacing(2.5)}`,
  minWidth: '250px',
  padding: `${theme.spacing(2.5)} 0`
}));
